(() => {
  const SELECTOR = '[data-eviva-parallax="true"]';
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function getEls(root = document) {
    return Array.from(root.querySelectorAll(SELECTOR));
  }

  function apply(el) {
    const vh = window.innerHeight || 800;
    const rect = el.getBoundingClientRect();

    const p = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
    const t = p - 0.5;

    const imgStrength = Number(el.dataset.imgStrength || 80);
    const patStrength = Number(el.dataset.patStrength || 160);

    el.style.setProperty('--bgY', (t * -imgStrength).toFixed(2) + 'px');
    el.style.setProperty('--patY', (t *  patStrength).toFixed(2) + 'px');
  }

  function updateAll(root = document) {
    getEls(root).forEach((el) => {
      // DEBUG VISUAL: se o JS rodou, você vai ver esse contorno verde por 2s
      el.classList.add('eviva-parallax--js-on');
      clearTimeout(el.__evivaTO);
      el.__evivaTO = setTimeout(() => el.classList.remove('eviva-parallax--js-on'), 2000);

      apply(el);
    });
  }

  // Garante que roda em tudo: load, DOMContentLoaded e eventos do editor
  const run = (root) => requestAnimationFrame(() => updateAll(root || document));

  document.addEventListener('DOMContentLoaded', () => run(document));
  window.addEventListener('load', () => run(document));
  window.addEventListener('scroll', () => run(document), { passive: true });
  window.addEventListener('resize', () => run(document));

  document.addEventListener('shopify:section:load', (e) => run(e.target));
  document.addEventListener('shopify:section:select', (e) => run(e.target));

  // Se o tema injeta conteúdo
  if ('MutationObserver' in window) {
    const mo = new MutationObserver(() => run(document));
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();